import {
  ArrDepSorting,
  FlightTableTab,
  ISelectionState
} from "./selectionSlice"

export function handleGetSelectionSliceInitValues(): ISelectionState {
  return {
    airportSeasonsSelector: {
      season: "",
      countries: [],
      airports: [],
      useLocalTime: false,
      useICAOCode: false
    },

    flightSelector: {
      values: {}
    },

    slotAvailabilitySelector: {
      values: {}
    },

    pagesHistory: {},

    collapsedCards: {
      flightID: false,
      period: false,
      times: true,
      other: true,
      handling: false,
      checkboxes: true
    },

    userSettings: {
      showOptionalFields: true,
      useSSIMView: true,
      pinSelectorPanel: false
    },

    flightTableSelection: {
      chosenFlightTableTab: FlightTableTab.default,
      chosenArrDepSorting: ArrDepSorting.ArrDep
    }
  }
}

